import React, { useState, useEffect, useRef } from 'react';
import { Routes, Route, Link } from 'react-router-dom';

import { useTimer } from '../../context/TimerContext';

import { usePageControl } from '../../context/PageControlContext';
import PageNavigation from '../../components/PageNavigation';

import Popup from '../../components/Popup';

import { useDeferUpdate } from '../../context/DeferUpdateContext';

import popupImage from '../../assets/images/skull.png';

function Module9() {

  // Page nav control
  const { canGoBack, setCanGoBack } = usePageControl();
  const { canContinue, setCanContinue } = usePageControl();

  useEffect(() => {
    setCanGoBack(false);
  }, [setCanGoBack]);
  
  useEffect(() => {
    setCanContinue(false);
  }, [setCanContinue]);

    const handleSuccess = () => {
    setCanContinue(true);
  };
  
  // Popup
  const [showPopup, setShowPopup] = useState(false);

  // - Time-based popup after page load
  const showAfterSeconds = 1; // Seconds

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, showAfterSeconds * 1000);

    return () => clearTimeout(timer);
  }, []);

    // Show/hide popup div content
    const [activeDiv, setactiveDiv] = useState(null);
    const [refreshKey, setRefreshKey] = useState(0); // Used to force re-render
  
    const handleOpen = (divId) => {
      setactiveDiv(divId);
      if (divId =='4' ){ // auto start the countdown on Popup div 4
        startCountdown();
      }
    };

    const handleClose = () => {
      setactiveDiv(null);
    };

  // Check Defer update status
 const { deferUpdate } = useDeferUpdate();


  // Timer
  const { timeRemaining, formatTime, isRunning } = useTimer();

  // Determine additional classes dynamically
  let additionalClasses = '';
    if (isRunning) {
      additionalClasses += ' timer-running';
    }
    if (timeRemaining <= 600 && timeRemaining >= 0) { // 10 mins or less but not negative
      additionalClasses += ' timer-warning';
    }
    if (timeRemaining < 0) { // time exceeded
      additionalClasses += ' timer-exceeded';
    } 

  // Go to next page
  const { goNext } = usePageControl();
   
  // Go to specific page
  const { setCurrentPage } = usePageControl();
  const goToPage = (pageId) => {
    setCurrentPage(pageId);
  };

  return (
    <div id="module-9" className="page physical">
        
        <header className="container-fluid">
            <div className="row">
                <div className="col-12">
                  <div id="CER"></div>
                  <div id="line"></div>
                  <div className={`timer-display${additionalClasses}`}>
                    <span className="timer-text">Time remaining <span className="timer-numbers">{formatTime(timeRemaining)}</span></span>
                  </div>
                </div>
            </div>
        </header>
    
        <main className="container-fluid">
            <div className="row">
                <div className="col-12">
                 

      <Popup
        className="popup-box-no-footer"
        title="Ransomware!"
        isOpen={showPopup}
        onClose={() => setShowPopup(false)}
      >

      <div id="popup-content">
      <div className="pop-up-image text-center"><img src={popupImage} className="popup-image" alt="Image of a skull"/></div>

      <h3>Oh no! Ransomware is trying to infect your system</h3>

                {!deferUpdate &&  (
                  <div id="popup-alert-1" className="popup-alert">
                    <p>Good job you installed the update! The ransomware fails to get in!</p>
                    <p>You can now continue.</p>
                    <button className="btn" onClick={() => { goNext(); }}>Close</button>
                  </div>
                )}

                {deferUpdate && (
                  <div id="popup-alert-2" className="popup-alert">
                    <p>You never patched the vulnerability! You have Ransomware once more!</p>
                    <p>You'll have to remove it again.</p>
                    <button className="btn btn-page-nav btn-continue" onClick={() => goToPage('module-5')}>Remove</button>
                  </div>
                )}

      </div>

      </Popup>

                </div>
            </div>
        </main>

        <footer className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <PageNavigation />
                </div>
            </div>
        </footer>
    
    </div>
  );
};

export default Module9;
